import { createUseStyles } from 'react-jss';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { colors } from '@insurancemenu/imenu-components-lib';
import { Props } from './index';

const styles: ComponentStylesProps<Props> = {
  wrapper: (props) => ({
    color: colors.neutral[props.theme],
  }),
  caption: {
    font: {
      size: '4.8rem',
      lineHeight: '6.4rem',
      weight: 700,
    },
    letterSpacing: '0.02rem',
    color: colors.neutral[900],
    margin: 0,
  },
  title: {
    font: {
      size: '14.4rem',
      lineHeight: '16rem',
      weight: 700,
    },
    letterSpacing: '0.02rem',
    color: colors.neutral[900],
    margin: {
      bottom: '8rem',
    },
  },
  subtitle: {
    font: {
      size: '2.8rem',
      lineHeight: '4rem',
      weight: 700,
    },
    letterSpacing: '0.02rem',
    color: colors.neutral[900],
    margin: {
      bottom: '1.6rem',
    },
    maxWidth: '34rem',
  },
  description: {
    maxWidth: '34rem',
    font: {
      size: '2rem',
      lineHeight: '2.8rem',
      weight: 500,
    },
    letterSpacing: '0.02rem',
    color: colors.neutral[900],
  },
  actionBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '42.8rem',
  },
  link: {
    textDecoration: 'none',
  },
  whiteHomeButton: {
    color: colors.neutral.black,
    '&:hover': {
      color: colors.neutral[800],
    },
  },
  whiteHelpButton: {
    '&:hover': {
      color: colors.neutral.black,
      backgroundColor: colors.neutral.white,
    },
  },
};
const createStyles = createUseStyles(styles);

export { styles, createStyles };
